import { Link } from "wouter";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";

interface DetailPageErrorProps {
  title: string;
  message: string;
  backHref: string;
  backText: string;
}

export function DetailPageError({ title, message, backHref, backText }: DetailPageErrorProps) {
  return (
    <div className="container mx-auto px-4 py-8">
      <div className="text-center">
        <h1 className="text-2xl font-bold mb-4">{title}</h1>
        <p className="text-gray-600 mb-4">{message}</p>
        <Link href={backHref}>
          <Button variant="outline">
            <ArrowLeft className="w-4 h-4 mr-2" />
            {backText}
          </Button>
        </Link>
      </div>
    </div>
  );
}
